module.exports = __webpack_public_path__ + "img/iasi_2kl.f1569b47.jpg";